import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.lastScrollTop = window.pageYOffset
    this.previousScrollTop = 0
    this.boundScroll = this.onScroll.bind(this)

    window.addEventListener("scroll", this.boundScroll)
    // Run once on load
    this.handleScroll(window.pageYOffset, 0)

    // Hide header on anchor navigation (initial load with hash + click on hash links)
    if (window.location.hash) this.#hideHeaderForAnchor()
    window.addEventListener("hashchange", () => this.#hideHeaderForAnchor())
  }

  disconnect() {
    window.removeEventListener("scroll", this.boundScroll)
  }

  onScroll() {
    const scrollTop = window.pageYOffset

    if (this.lastScrollTop === scrollTop) {
      return
    }

    this.previousScrollTop = this.lastScrollTop
    this.lastScrollTop = scrollTop

    this.handleScroll(scrollTop, this.previousScrollTop)
  }

  handleScroll(offset, previousOffset) {
    document.documentElement.classList.toggle('scrolled', offset > 150)
    document.documentElement.classList.toggle('scrolled-up', offset < previousOffset)
  }

  #hideHeaderForAnchor() {
    document.documentElement.classList.add('scrolled')
    document.documentElement.classList.remove('scrolled-up')
  }
}
